import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.page.jsx'
import './index.css'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeI9kopAAAAAGHElgDitINrBU3umboUcSQ9mv6f"
      language="ja"
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
)
